export const ROUTES = {
  QUERYPARAMS: "/:instanceid?",
  HOME: "/",
  DASHBOARD: "/dashboard",
  ACCOUNT: "/account",
  APPS: "/apps",
  SECURITY: "/security",
  SURVEYS: "/surveys",
  SURVEY_CREATE: "/surveys/new",
  SURVEY_DETAIL: "/surveys/:id",
  SURVEY_EDIT: "/surveys/:id/edit",
  SURVEY_PREVIEW: "/surveys/:id/preview",
  SURVEY_RESULTS: "/surveys/results",
  SURVEY_RESULTS_DETAIL: "/surveys/results/:id",
  SURVEY_REQUESTS: "/surveys/requests",
  SURVEY_TEMPLATES: "/surveys/templates",
  PUBLIC_SURVEY: "/survey/:instanceId/:token",

  // Auth & system routes
  ERRORPAGE: "/errorpage",
  CALLBACK: "/callback",
  SKYPOINTLOGIN: "/skypointlogin",
  SKYPOINTSIGNUP: "/skypointsignup",

  // Merged Routes (New /clean paths)
  VIEWINSTANCES: "/instances",
  VIEWINSTANCEDETAILS: "/instanceDetails",
  VIEWINSTANCEHISTORY: "/instanceHistory",
  VIEWINSTANCEBACKUP: "/instanceBackup",
  TENANTSETIINGS: "/tenants",
  CREATETENANT: "/createTenant",
  LOGS: "/logs",
  USERS: "/users",
  ROLES: "/roles",
  END_USERS: "/end-users",
  GENERAL_SETTINGS: "/general-settings",
  EMAIL_SETTINGS: "/email-settings",
  APP_PREFERENCES: "/settings/app-preferences",
  FIELDS: "/fields",
  UTM_ANALYTICS: "/utm-analytics",
  CAMPAIGN_ATTRIBUTION: "/campaign-attribution",
  LEADS: "/leads",
  LEAD_DETAIL: "/leads/:leadId",
  CRM_INTEGRATIONS: "/crm-integrations",
  INTEGRATION_SETTINGS: "/settings/integrations",
  FORMS: "/forms",
  FORM_BUILDER: "/forms/:id/edit",
  CAMPAIGNS: "/campaigns",
  CAMPAIGN_BUILDER: "/campaigns/:id/edit",
  CONTENT_HUB: "/content-hub",
  LANDING_PAGES: "/landing-pages",
  LANDING_PAGE_BUILDER: "/landing-pages/:id",
  INQUIRY_TYPES: "/inquiry-types",
  AB_TESTS: "/ab-tests",
  FLOOR_PLANS: "/floor-plans",
  TESTIMONIALS: "/testimonials",
  LEAD_MAGNETS: "/lead-magnets",
  TOUR_AVAILABILITY: "/tour-availability",
  SCHEDULED_TOURS: "/scheduled-tours",
  ALERT_BANNERS: "/alert-banners",
  VIDEOS: "/videos",
  FAQ: "/faq",
  STAFF_PROFILES: "/staff-profiles",
  SMS_ALERT_SETTINGS: "/sms-alert-settings",
  SCHEDULE: "/schedule",
  SCHEDULE_CALENDAR: "/schedule/calendar",
  SCHEDULE_OPEN_SHIFTS: "/schedule/open-shifts",
  SCHEDULE_TEMPLATES: "/schedule/templates",
  SCHEDULE_ANALYTICS: "/schedule/analytics",
  CREDENTIALS: "/credentials",
  CREDENTIALS_TYPES: "/credentials/types",
  CREDENTIALS_COMPLIANCE: "/credentials/compliance",
  DOCUMENT_TEMPLATES: "/sign/templates",
  TEMPLATE_NEW: "/sign/templates/new",
  TEMPLATE_EDITOR: "/sign/templates/:templateId/edit",
  TEMPLATE_EDITOR_NEW: "/sign/templates/new/edit",
  ENVELOPES: "/sign/envelopes",
  ENVELOPE_NEW: "/sign/envelopes/new",
  ENVELOPE_DETAIL: "/sign/envelopes/:envelopeId",
  ENVELOPE_BULK: "/sign/envelopes/bulk",
  IN_PERSON_SIGNING: "/sign/in-person",
  SELF_SIGN: "/sign/self-sign",
  CONTACTS: "/sign/contacts",
  POWERFORMS: "/sign/powerforms",
  POWERFORM_NEW: "/sign/powerforms/new",
  POWERFORM_DETAIL: "/sign/powerforms/:powerformId",
  WEB_FORMS: "/sign/web-forms",
  WEB_FORM_EDIT: "/sign/web-forms/:id/edit",
  SIGNING_ANALYTICS: "/insights/analytics",
  WEBHOOKS: "/settings/webhooks",
  SENIOR_LIVING: "/senior-living",
  SENIOR_LIVING_RESIDENTS: "/senior-living/residents",
  SENIOR_LIVING_RESIDENT_DETAIL: "/senior-living/residents/:residentId",
  SENIOR_LIVING_MOVE_IN_PACKETS: "/senior-living/move-in-packets",
  SENIOR_LIVING_PACKET_DASHBOARD: "/senior-living/packet-dashboard",
  SENIOR_LIVING_COMMUNITY_DASHBOARD: "/senior-living/community-dashboard",
  HEALTH_PLAN: "/health-plan",
  HEALTH_PLAN_PARTICIPANTS: "/health-plan/participants",
  HEALTH_PLAN_PARTICIPANT_DETAIL: "/health-plan/participants/:participantId",
  HEALTH_PLAN_REPRESENTATIVES: "/health-plan/representatives",
  HEALTH_PLAN_ENROLLMENT: "/health-plan/enrollment",
  ADMIN_BULK_SEND: "/admin/bulk-send",
  ADMIN_BULK_SEND_NEW: "/admin/bulk-send/new",
  ADMIN_BULK_SEND_DETAIL: "/admin/bulk-send/:jobId",
  NAVIGATOR: "/navigator",
  NAVIGATOR_AGREEMENTS: "/navigator/agreements",
  NAVIGATOR_AGREEMENT_DETAIL: "/navigator/agreements/:agreementId",
  NAVIGATOR_ALERTS: "/navigator/alerts",
  EMBED_SEND: "/embed/send",
  AUTHORIZED_SIGNER_PORTAL: "/portal/authorized-signer",
  // People
  PEOPLE_CONTACTS: "/contacts",
  PEOPLE_CONTACT_DETAIL: "/contacts/:contactId",
  PEOPLE_ORGANIZATIONS: "/organizations",
  PEOPLE_ORGANIZATION_DETAIL: "/organizations/:orgId",

  // Tickets (cross-portal view)
  TICKETS: "/tickets",
  INBOX: "/inbox",

  // Portals (project management)
  PORTALS_CREATE: "/portals/new",
  PORTALS: "/portals",
  PORTALS_YOUR_WORK: "/your-work",
  PORTALS_DASHBOARD: "/portals/dashboard",
  PORTAL_BOARD: "/portals/:portalKey/board",
  PORTAL_LIST: "/portals/:portalKey/list",

  PORTAL_CALENDAR: "/portals/:portalKey/calendar",

  PORTAL_ITEM_DETAIL: "/portals/:portalKey/items/:itemKey",
  PORTAL_ITEM_NEW: "/portals/:portalKey/items/new",
  PORTAL_SETTINGS: "/portals/:portalKey/settings",
  PORTAL_SETTINGS_DETAILS: "/portals/:portalKey/settings/details",
  PORTAL_SETTINGS_ACCESS: "/portals/:portalKey/settings/access",
  PORTAL_SETTINGS_WORKFLOW: "/portals/:portalKey/settings/workflow",
  PORTAL_SETTINGS_SERVICE_DESK: "/portals/:portalKey/settings/service-desk",
  PORTAL_SETTINGS_REQUEST_TYPE_EDIT: "/portals/:portalKey/settings/request-types/:requestTypeId",
  PORTAL_SETTINGS_AGENT_GROUPS: "/portals/:portalKey/settings/agent-groups",
  PORTAL_SETTINGS_QUEUES: "/portals/:portalKey/settings/queues",

  PORTAL_SETTINGS_EMAIL: "/portals/:portalKey/settings/email",
  PORTAL_SETTINGS_ASSIGNMENT_MATRIX: "/portals/:portalKey/settings/assignment-matrix",
  PORTAL_QUEUES: "/portals/:portalKey/queues",
  PORTAL_QUEUE_VIEW: "/portals/:portalKey/queues/:queueId",
  PORTAL_SETTINGS_CUSTOM_FIELDS: "/portals/:portalKey/settings/custom-fields",
  PORTAL_SETTINGS_SLA: "/portals/:portalKey/settings/sla-policies",
  PORTAL_SETTINGS_RECURRING_TICKETS: "/portals/:portalKey/settings/recurring-tickets",
  PORTAL_SETTINGS_SCHEDULED_REPORTS: "/portals/:portalKey/settings/scheduled-reports",
  PORTAL_SETTINGS_BUSINESS_HOURS: "/portals/:portalKey/settings/business-hours",
  PORTAL_SETTINGS_AUTOMATIONS: "/portals/:portalKey/settings/automations",
  PORTAL_SETTINGS_MACROS: "/portals/:portalKey/settings/macros",
  PORTAL_SETTINGS_AUTOMATION_EDIT: "/portals/:portalKey/settings/automations/:ruleId",
  PORTAL_SETTINGS_KNOWLEDGE_BASE: "/portals/:portalKey/settings/knowledge-base",
  PORTAL_SETTINGS_KB_ARTICLE_NEW: "/portals/:portalKey/settings/knowledge-base/new",
  PORTAL_SETTINGS_KB_ARTICLE_EDIT: "/portals/:portalKey/settings/knowledge-base/:articleId/edit",
  PORTAL_SETTINGS_CSAT: "/portals/:portalKey/settings/csat",
  PORTAL_SETTINGS_NPS: "/portals/:portalKey/settings/nps",
  PORTAL_SETTINGS_INTEGRATIONS: "/portals/:portalKey/settings/integrations",
  PORTAL_SETTINGS_HUBSPOT: "/portals/:portalKey/settings/data-sync/hubspot",
  PORTAL_SETTINGS_SHAREPOINT: "/portals/:portalKey/settings/data-sync/sharepoint",
  PORTAL_SETTINGS_DATA_SYNC: "/portals/:portalKey/settings/data-sync",
  PORTAL_REPORTS: "/portals/:portalKey/reports",
  PORTAL_REPORT_CREATED_VS_RESOLVED: "/portals/:portalKey/reports/created-vs-resolved",
  PORTAL_REPORT_SLA_COMPLIANCE: "/portals/:portalKey/reports/sla-compliance",
  PORTAL_REPORT_AGENT_PERFORMANCE: "/portals/:portalKey/reports/agent-performance",
  PORTAL_REPORT_REQUEST_TYPES: "/portals/:portalKey/reports/request-types",
  PORTAL_REPORT_RESOLUTION_TIME: "/portals/:portalKey/reports/resolution-time",

  // Customer portal settings (admin-facing)
  CUSTOMER_PORTAL_SETTINGS: "/settings/customer-portal",

  // User manual
  USER_MANUAL: "/settings/user-manual",

  // Customer portal (end-user facing)
  CUSTOMER_PORTALS: "/customer/portals",
  CUSTOMER_PORTAL_DETAIL: "/customer/portals/:portalKey",
  CUSTOMER_MY_REQUESTS: "/customer/my-requests",
  CUSTOMER_REQUEST_DETAIL: "/customer/portals/:portalKey/requests/:itemKey",
  CUSTOMER_KNOWLEDGE_BASE: "/customer/portals/:portalKey/kb",
  CUSTOMER_KB_ARTICLE: "/customer/portals/:portalKey/kb/:slug",
  CUSTOMER_MY_WORKSPACE: "/customer/my-workspace",
  CUSTOMER_MY_TEAM: "/customer/my-team",
  CUSTOMER_MY_ORG: "/customer/my-org",

  // Custom domain routes (same pages, no /customer prefix)
  CUSTOM_DOMAIN_PORTALS: "/portals",
  CUSTOM_DOMAIN_PORTAL_DETAIL: "/portals/:portalKey",
  CUSTOM_DOMAIN_MY_REQUESTS: "/my-requests",
  CUSTOM_DOMAIN_REQUEST_DETAIL: "/portals/:portalKey/requests/:itemKey",
  CUSTOM_DOMAIN_KNOWLEDGE_BASE: "/portals/:portalKey/kb",
  CUSTOM_DOMAIN_KB_ARTICLE: "/portals/:portalKey/kb/:slug",
  CUSTOM_DOMAIN_MY_WORKSPACE: "/my-workspace",
  CUSTOM_DOMAIN_MY_TEAM: "/my-team",
  CUSTOM_DOMAIN_MY_ORG: "/my-org",

  PORTAL_REPORT_CSAT: "/portals/:portalKey/reports/csat",
  PORTAL_REPORT_NPS: "/portals/:portalKey/reports/nps",
  PORTAL_SETTINGS_ARCHIVED: "/portals/:portalKey/settings/archived",
  PORTAL_SETTINGS_BIN: "/portals/:portalKey/settings/bin",
  PORTAL_REPORT_BUILDER: "/portals/:portalKey/reports/builder",
  PORTAL_REPORT_BUILDER_EDIT: "/portals/:portalKey/reports/builder/:reportId",
  PORTAL_CUSTOM_REPORT: "/portals/:portalKey/reports/custom/:reportId",
  PORTAL_SETTINGS_REPORTS: "/portals/:portalKey/settings/reports",
  PORTAL_SETTINGS_AI_AGENT: "/portals/:portalKey/settings/ai-agent",
  PORTAL_SETTINGS_FORMS: "/portals/:portalKey/settings/forms",
  PORTAL_SETTINGS_CUSTOM_REPORTS: "/portals/:portalKey/settings/custom-reports",
  FORM_FILL: "/forms/:formId",
  AI_PLAYGROUND: "/ai-playground",
  // skyAgent + skyBrain
  SKYAGENT: "/skyagent",
  SKYBRAIN: "/skybrain",
  SKYBRAIN_INDEX: "/skybrain/index",
  SKYBRAIN_SETTINGS: "/skybrain/settings",
  SKYBRAIN_SYSTEM_PROMPT: "/skybrain/system-prompt",
  SKYBRAIN_MEMORY: "/skybrain/memory",
  SKYBRAIN_SKILLS: "/skybrain/skills",
  SKYBRAIN_INTEGRATIONS: "/skybrain/integrations",
  SKYAGENT_PROJECTS: "/skyagent/projects",
  SKYAGENT_ARTIFACTS: "/skyagent/artifacts",
  SKYAGENT_SCHEDULES: "/skyagent/schedules",
  // Kept for one release as redirects to their skyBrain successors.
  SKYAGENT_SKILLS: "/skyagent/skills",
  SKYAGENT_CUSTOMIZE: "/skyagent/customize",
  SKYAGENT_CONFIGURATION: "/skyagent/configuration",
  // skyEmployee (employee experience) — third product surface
  EMPLOYEE: "/employee",
  EMPLOYEE_HOME: "/employee/home",
  EMPLOYEE_ADMIN_USERS: "/employee/admin/users",
  EMPLOYEE_ADMIN_SETTINGS: "/employee/admin/settings",
  EMPLOYEE_ADMIN_MESSAGING: "/employee/admin/messaging",
  // Administration → Recognition: award badges and e-card designs (Phase 4).
  EMPLOYEE_ADMIN_RECOGNITION: "/employee/admin/recognition",
  EMPLOYEE_ADMIN_GIFTCARDS: "/employee/admin/giftcards",
  EMPLOYEE_ADMIN_LIBRARY: "/employee/admin/library",
  // The old Reported messages address: redirects to Manage → Reports → Messages.
  EMPLOYEE_ADMIN_MESSAGE_REPORTS: "/employee/admin/message-reports",
  // Manage → Reports: reported posts and comments, and reported messages, each
  // tab behind its own capability (messages stay Admin-only).
  EMPLOYEE_MANAGE_REPORTS: "/employee/manage/reports",
  EMPLOYEE_MANAGE_SCOPE: "/employee/manage/scope",
  // Manage → Content: announcements and spotlights, surveys, polls, banners,
  // moderation.
  EMPLOYEE_MANAGE_CONTENT: "/employee/manage/content",
  EMPLOYEE_MANAGE_ACKS: "/employee/manage/acks",
  // Manage → Broadcasts: messages from the organisation to staff, lists, fields.
  EMPLOYEE_MANAGE_BROADCASTS: "/employee/manage/broadcasts",
  // Writing a broadcast (?b=<id> for a draft) and a broadcast's report (?b=<id>).
  EMPLOYEE_MANAGE_BROADCAST_COMPOSE: "/employee/manage/broadcasts/compose",
  EMPLOYEE_MANAGE_BROADCAST_REPORT: "/employee/manage/broadcasts/report",
  EMPLOYEE_MANAGE_REWARDS: "/employee/manage/rewards",
  // The old Manage → Surveys and polls address: redirects to Content's
  // Surveys or Polls tab.
  EMPLOYEE_MANAGE_SURVEYS: "/employee/manage/surveys",
  // Header → View profile while in skyEmployee's admin view.
  EMPLOYEE_PROFILE: "/employee/profile",
  EMPLOYEE_NOTIFICATION_SETTINGS: "/employee/notification-settings",
  // The employee-facing view of skyEmployee, reached via Portal View → User Portal.
  EMPLOYEE_MY_HOME: "/employee/my/home",
  // One post (P3-6): where Copy link and the bell lead.
  EMPLOYEE_MY_POST: "/employee/my/home/post/:postId",
  EMPLOYEE_MY_REQUESTS: "/employee/my/requests",
  // A request, and raising one: the Service Desk customer portal pages shown
  // inside skyEmployee (new requests live apart from /requests/:portalKey so no
  // portal key, "NEW" included, can clash with them).
  EMPLOYEE_MY_REQUEST_DETAIL: "/employee/my/requests/:portalKey/:itemKey",
  EMPLOYEE_MY_NEW_REQUEST: "/employee/my/new-request",
  EMPLOYEE_MY_NEW_REQUEST_PORTAL: "/employee/my/new-request/:portalKey",
  EMPLOYEE_MY_NEW_REQUEST_HELP: "/employee/my/new-request/:portalKey/help",
  EMPLOYEE_MY_NEW_REQUEST_ARTICLE: "/employee/my/new-request/:portalKey/help/:slug",
  EMPLOYEE_MY_MESSAGES: "/employee/my/messages",
  EMPLOYEE_MY_DIRECTORY: "/employee/my/directory",
  EMPLOYEE_MY_REWARDS: "/employee/my/rewards",
  EMPLOYEE_MY_LEADERBOARD: "/employee/my/leaderboard",
  // The open surveys I haven't answered (one is answered under it).
  EMPLOYEE_MY_SURVEYS: "/employee/my/surveys",
  // Answering a survey (#1204). Reached from the due list, not the menu.
  EMPLOYEE_MY_SURVEY: "/employee/my/surveys/:runId",
  EMPLOYEE_MY_RESOURCES: "/employee/my/resources",
  EMPLOYEE_MY_PROFILE: "/employee/my/profile",
  EMPLOYEE_MY_NOTIFICATION_SETTINGS: "/employee/my/notification-settings",
  // Workforce Lifecycle Management
  WORKFORCE: "/workforce",
  WORKFORCE_SETUP: "/workforce/setup",
  // Workforce Settings — the single home for all WLM config authoring
  // (departments/roles, asset types, licenses, onboarding checklists, sector
  // pack). Operational pages read/use this config but no longer author it.
  WORKFORCE_SETTINGS: "/workforce/settings",
  WORKFORCE_SETTINGS_DEPARTMENTS: "/workforce/settings/departments",
  WORKFORCE_SETTINGS_LOCATIONS: "/workforce/settings/locations",
  WORKFORCE_SETTINGS_ASSET_TYPES: "/workforce/settings/asset-types",
  WORKFORCE_SETTINGS_LICENSES: "/workforce/settings/licenses",
  WORKFORCE_SETTINGS_CHECKLISTS: "/workforce/settings/checklists",
  WORKFORCE_SETTINGS_TICKET_TEMPLATES: "/workforce/settings/ticket-templates",
  WORKFORCE_SETTINGS_PACK: "/workforce/settings/pack",
  WORKFORCE_SETTINGS_AUTOMATION: "/workforce/settings/automation",
  WORKFORCE_SETTINGS_ACCESS_GRANTS: "/workforce/settings/access-grants",
  WORKFORCE_SETTINGS_DIRECTORY_SYNC: "/workforce/settings/directory-sync",
  WORKFORCE_SETTINGS_SOD: "/workforce/settings/separation-of-duties",
  WORKFORCE_SETTINGS_APPROVERS: "/workforce/settings/approvers",
  WORKFORCE_PEOPLE: "/workforce/people",
  WORKFORCE_PERSON: "/workforce/people/:agentId",
  WORKFORCE_ORG: "/workforce/org",
  WORKFORCE_DIRECTORY: "/workforce/directory",
  WORKFORCE_DASHBOARDS: "/workforce/dashboards",
  WORKFORCE_APPLICATIONS: "/workforce/applications",
  WORKFORCE_APPLICATION_ACCESS: "/workforce/applications/:slug",
  WORKFORCE_ROLES: "/workforce/roles",
  WORKFORCE_LIFECYCLE: "/workforce/lifecycle",
  WORKFORCE_ASSETS: "/workforce/assets",
  WORKFORCE_ASSET_TYPES: "/workforce/asset-types",
  WORKFORCE_LICENSES: "/workforce/licenses",
  WORKFORCE_REPORTS: "/workforce/reports",
  WORKFORCE_CERTIFICATIONS: "/workforce/certifications",
  WORKFORCE_ACCESS_REQUESTS: "/workforce/access-requests",
  WORKFORCE_ACCESS: "/workforce/access",
  SURVEY: "/survey/:token",
  INSTRUMENTATIONKEYREACT: "c433df71-1d5b-4a1b-b68a-b0b95f53cd93",
  SIGNUP: "/signup",
} as const;

const DocumentLink: Record<string, string> = {
  ":instanceid?": "/overview",
  "/": "/home",
  "/apps": "/overview",
  "/settings/session": "/tenant",
  "/security": "/security",
  "/privacycenter": "/privacycenter",
  "/editprivacycenter": "/editprivacycenter",
  "/datasubjectrequests": "/datasubjectrequest",
  "/datasubjectrequestcreate": "/datasubjectrequest",
  "/templates": "/privacytemplates",
  "/edittemplate": "/privacytemplates",
  "/reports": "/privacyreports",
  "/reportconsent": "/reports",
  "/errorpage": "/errorpage",
  "/callback": "/callback",
  "/skypointlogin": "/login",
  "/skypointsignup": "/signup",
  "/tabledata": "/tabledata",
  "/overlapdetails": "/overlapdetails",
  "/differentiatordetails": "/audiences",
  "/settings/instances": "/instance",
  "/settings/instanceDetails": "/instance",
  "/settings/instanceHistory": "/instance",
  "/settings/instanceBackup": "/instance",
  "/schedule": "/schedule",
  "/settings/tenants": "/tenant",
  "/transformations": "/transformations",
};

export const PREVIEWFIELDS = {
  date: new Date(Date.UTC(2012, 1, 20, 3, 0, 0)),
};
export const PREVIEWNUMBER = 456789.12;
export const PREVIEWPERCENTAGE = 12.8;

export const TIMEOUT_LOW = 10000;
export const TIMEOUT_MEDIUM = 20000;

export const ADD_NOTIFICATION = "ADD_NOTIFICATION";
export const REMOVE_NOTIFICATION = "REMOVE_NOTIFICATION";
export const RESET = "RESET";

export const SUCCESS_MESSAGE = "successMessage";
export const ERROR_MESSAGE = "errorMessage";
export const SUCCESS_MESSAGE_BAR = "successMessageBar";
export const ERROR_MESSAGE_BAR = "errorMessageBar";
export const SUCCESS_MESSAGE_DASHBOARD = "successMessageDashboard";
const ERROR_MESSAGE_DASHBOARD = "errorMessageDashboard";
const WARNING_MESSAGE_DASHBOARD = "warningMessageDashboard";

const BANKACCOUNTHOLDER = {
  INDIVIDUAL: "Individual",
  COMPANY: "Company",
} as const;

export const CONSTANTS = {
  tableLowerCase: "table",
  tableUpperCase: "Table",
  tablesLowerCase: "tables",
  tablesUpperCase: "Tables",
  database: "Database",
  databases: "Databases",
  tableName: "Table name",
} as const;

export const FILTER_OPTIONS = [
  "Contains",
  "Does not contain",
  "Start with",
  "Ends with",
  "Is null",
  "Is not null",
] as const;

export const INSTANCE_HISTORY_ACTION_TYPES = {
  Create: "Create",
  Edit: "Edit",
} as const;

export const INSTANCE_HISTORY_STATUS_TYPES = {
  Success: "Success",
  Failed: "Failed",
} as const;

export const COMMON_NOTIFICATION_MESSAGES = {
  errorMessage: "Something went wrong",
} as const;

const DOCUMENT_UPLOAD = {
  acceptedMimeTypes: [
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ],
  acceptedExtensions: ".pdf,.doc,.docx",
  acceptAttribute:
    ".pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  maxSizeMB: 50,
  maxSizeBytes: 50 * 1024 * 1024,
} as const;

function isAcceptedDocumentType(mimeType: string): boolean {
  return DOCUMENT_UPLOAD.acceptedMimeTypes.includes(
    mimeType as (typeof DOCUMENT_UPLOAD.acceptedMimeTypes)[number],
  );
}
